// Color group data for RepMates color palette
// This file is imported by ColorPaletteSection and ShowGroupColors

const colorGroups = [
  {
    group: "Primary Colors",
    colors: [{ name: "primary", var: "--color-primary", hex: "#006373" }],
  },
  {
    group: "Accent Colors",
    description: [
      "Accent Colors 是用来吸引用户注意力、强调重要元素和创造视觉层次的关键颜色",
      "命名规则：「bg」表示背景色，「fg」表示前景色（比如文字）",
      "默认情况下，「bg」色应该比「fg」更深",
      "根据情绪温度，从最低调到最显眼依次为「cold」 → 「warm」 → 「cool」 → 「hot」四级",
    ],
    types: [
      {
        type: "hot",
        colors: [
          {
            name: "accent-bg-hot",
            var: "--color-accent-bg-hot",
            hex: "#6030c1",
          },
          {
            name: "accent-fg-hot",
            var: "--color-accent-fg-hot",
            hex: "#f2ebff",
          },
        ],
      },
      {
        type: "warm",
        colors: [
          {
            name: "accent-bg-warm",
            var: "--color-accent-bg-warm",
            hex: "#dda200",
          },
          {
            name: "accent-fg-warm",
            var: "--color-accent-fg-warm",
            hex: "#f7f1df",
          },
        ],
      },
      {
        type: "cool",
        colors: [
          {
            name: "accent-bg-cool",
            var: "--color-accent-bg-cool",
            hex: "#5c751e",
          },
          {
            name: "accent-fg-cool",
            var: "--color-accent-fg-cool",
            hex: "#f2f4ed",
          },
        ],
      },
      {
        type: "cold",
        colors: [
          {
            name: "accent-bg-cold",
            var: "--color-accent-bg-cold",
            hex: "#297164",
          },
          {
            name: "accent-fg-cold",
            var: "--color-accent-fg-cold",
            hex: "#eff6f4",
          },
        ],
      },
    ],
  },
  {
    group: "Status Colors",
    description: [
      "「icon」表示图标的色；「bg」表示背景色；「fg」表示前景色（文字）；「bd」表示边框色",
      "「bd」色必须比「base」色的10% 更深",
      "根据状态的类型分为「success」（成功）、「caution」（注意）、「error」（错误）三种",
    ],
    types: [
      {
        type: "success",
        colors: [
          {
            name: "status-icon-success",
            var: "--color-status-icon-success",
            hex: "#469c5e",
          },
          {
            name: "status-bg-success",
            var: "--color-status-bg-success",
            hex: "#ecf2ed",
          },
          {
            name: "status-bd-success",
            var: "--color-status-bd-success",
            hex: "#d6eada",
          },
          {
            name: "status-fg-success",
            var: "--color-status-fg-success",
            hex: "#222920",
          },
        ],
      },
      {
        type: "caution",
        colors: [
          {
            name: "status-icon-caution",
            var: "--color-status-icon-caution",
            hex: "#e6c90f",
          },
          {
            name: "status-bg-caution",
            var: "--color-status-bg-caution",
            hex: "#fbf7e9",
          },
          {
            name: "status-bd-caution",
            var: "--color-status-bd-caution",
            hex: "#e6e0b7",
          },
          {
            name: "status-fg-caution",
            var: "--color-status-fg-caution",
            hex: "#3b3b34",
          },
        ],
      },
      {
        type: "error",
        colors: [
          {
            name: "status-icon-error",
            var: "--color-status-icon-error",
            hex: "#ec5b4a",
          },
          {
            name: "status-bg-error",
            var: "--color-status-bg-error",
            hex: "#fdeceb",
          },
          {
            name: "status-bd-error",
            var: "--color-status-bd-error",
            hex: "#fadfe1",
          },
          {
            name: "status-fg-error",
            var: "--color-status-fg-error",
            hex: "#352f2e",
          },
        ],
      },
    ],
  },
  {
    group: "Text Colors",
    colors: [
      {
        name: "tx-dark",
        var: "--color-tx-dark",
        hex: "#14212c",
      },
      {
        name: "tx-default",
        var: "--color-tx-default",
        hex: "#373e44",
      },
      {
        name: "tx-primary",
        var: "--color-tx-primary",
        hex: "#408091",
      },
      {
        name: "tx-muted",
        var: "--color-tx-muted",
        hex: "#8e9daf",
      },
      {
        name: "tx-error",
        var: "--color-tx-error",
        hex: "#fadfe1",
      },
    ],
  },
  {
    group: "Background Colors",
    description: [
      "「base」表示默认背景色",
      "「light」表示比默认背景色更浅一些",
      "「overlay」表示比默认背景色更深一些",
      "背景色均可以叠加使用，比如：在「bg-base」上叠加一个新的组件并使用「bg-light」，然后再放一个「bg-overlay」",
    ],
    colors: [
      { name: "bg-base", var: "--color-bg-base", hex: "#f8f7f6" },
      { name: "bg-light", var: "--color-bg-light", hex: "#fdfcfc" },
      {
        name: "bg-overlay",
        var: "--color-bg-overlay",
        hex: "#efedeb",
      },
    ],
  },
  {
    group: "Border Colors",
    description: [
      "「bd」表示边框色，是「border」的缩写",
      "可以跟背景色搭配使用，比如：「bg-base」的组件，可以使用「bd-base」的颜色作为边框",
    ],
    colors: [
      { name: "bd-base", var: "--color-bd-base", hex: "#dbdfe6" },
      { name: "bd-light", var: "--color-bd-light", hex: "#f8f7f6" },
      {
        name: "bd-overlay",
        var: "--color-bd-overlay",
        hex: "#e8e5e3",
      },
      { name: "bd-dark", var: "--color-bd-dark", hex: "#373e44" },
    ],
  },
  {
    group: "Button Colors",
    description: [
      "命名规则：「bg」表示背景色，「fg」表示前景色（比如文字）",
      "「Primary」：用于页面最主要的操作，如「立即付款」",
      "「Secondary」：用于辅助操作，通常是「返回上一步」或「保存草稿」",
      "「Outline」：用于轻量级操作，如「修改头像」",
      "「Caution」：用于需要提醒风险的操作，如「调整权限」",
      "「Destructive」：用于需要删除或破坏的操作，如「删除账户」",
      "「Link」：用于跳转链接，如「忘记密码？」",
    ],
    types: [
      {
        type: "primary",
        colors: [
          {
            name: "bg-primary",
            var: "--color-btn-bg-primary",
            hex: "#006373",
          },
          {
            name: "fg-primary",
            var: "--color-btn-fg-primary",
            hex: "#fdfcfc",
          },
        ],
      },
      {
        type: "secondary",
        colors: [
          {
            name: "bg-secondary",
            var: "--color-btn-bg-secondary",
            hex: "#f8f7f6",
          },
          {
            name: "fg-secondary",
            var: "--color-btn-fg-secondary",
            hex: "#14212c",
          },
        ],
      },
      {
        type: "outline",
        colors: [
          {
            name: "bd-outline",
            var: "--color-btn-bd-outline",
            hex: "#373e44",
          },
          {
            name: "fg-outline",
            var: "--color-btn-fg-outline",
            hex: "#373e44",
          },
        ],
      },
      {
        type: "caution",
        colors: [
          {
            name: "bg-caution",
            var: "--color-btn-bg-caution",
            hex: "#e6e0b7",
          },
          {
            name: "fg-caution",
            var: "--color-btn-fg-caution",
            hex: "#3b3b34",
          },
        ],
      },
      {
        type: "destructive",
        colors: [
          {
            name: "bg-destructive",
            var: "--color-btn-bg-destructive",
            hex: "#fadfe1",
          },
          {
            name: "fg-destructive",
            var: "--color-btn-fg-destructive",
            hex: "#ec5b4a",
          },
        ],
      },
      {
        type: "link",
        colors: [
          {
            name: "fg-link",
            var: "--color-btn-fg-link",
            hex: "#14212c",
          },
        ],
      },
    ],
  },
];

export default colorGroups;
